import { goodsState, goodsType, collationRules, couponStatusArr, discountType, publishType, grantObj, promotionTypes, cycleTypes, dayTypes, vendorsType, invoiceType, invoiceProvideType, ucasStatusOptions, secondGenerationOptions } from 'json/mall-options'
export function getGoodsState (val) {
  let label
  goodsState.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
export function getGoodsType (val) {
  let label
  goodsType.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
export function getucasStatusType (val) {
  let label
  ucasStatusOptions.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
export function getSecondGenerationSequencing (val) {
  let label
  secondGenerationOptions.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
export function getCollationRules (val) {
  let label
  collationRules.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
export function getCouponStatus (val) {
  let label
  couponStatusArr.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 优惠劵优惠形式
export function getDiscountType (val) {
  let label
  discountType.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 优惠劵发布方式
export function getPublishType (val) {
  let label
  publishType.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
export function getGrantObj (val) {
  let label
  grantObj.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 促销活动类型
export function getPromotionType (val) {
  let label
  promotionTypes.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 商品周期type
export function getCycleTypes (val) {
  let label
  cycleTypes.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 检测项周期
export function getDayTypes (val) {
  let label
  dayTypes.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 枚举查询。传入数组和值
export function getEnumeration (Arr, val) {
  let label
  Arr.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 枚举查询。传入数组和值
export function formatVendorsType (val) {
  let label
  vendorsType.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 枚举查询。传入数组和值
export function formatInvoiceType (val) {
  let label
  invoiceType.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
// 枚举查询。传入数组和值
export function formatInvoiceProvideType (val) {
  console.log('==val',val)
  let label
  invoiceProvideType.forEach(item => {
    if (item.value === val) {
      label = item.label
    }
  })
  return label
}
